import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const OpeningHoursInput = ({ value, onChange }) => {
  const { t } = useTranslation();

  const DAY_LABELS = {
    Monday: t('dayMonday', 'Monday'),
    Tuesday: t('dayTuesday', 'Tuesday'),
    Wednesday: t('dayWednesday', 'Wednesday'),
    Thursday: t('dayThursday', 'Thursday'),
    Friday: t('dayFriday', 'Friday'),
    Saturday: t('daySaturday', 'Saturday'),
    Sunday: t('daySunday', 'Sunday'),
  };

  const [hours, setHours] = useState(() => {
    if (value) {
      return value;
    }
    return DAYS.reduce((acc, day) => {
      acc[day] = { open: false, from: '09:00', to: '17:00' };
      return acc;
    }, {});
  });

  const handleDayToggle = (day) => {
    const newHours = {
      ...hours,
      [day]: { ...hours[day], open: !hours[day].open }
    };
    setHours(newHours);
    updateParent(newHours);
  };

  const handleTimeChange = (day, field, val) => {
    const newHours = {
      ...hours,
      [day]: { ...hours[day], [field]: val }
    };
    setHours(newHours);
    updateParent(newHours);
  };

  const updateParent = (hoursData) => {
    const formatted = DAYS
      .filter(day => hoursData[day].open)
      .map(day => `${day}: ${hoursData[day].from}-${hoursData[day].to}`)
      .join('; ');
    onChange(formatted || 'Closed');
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
        <Clock className="h-4 w-4" />
        <span>{t('selectDaysHours', 'Select days and set opening hours')}</span>
      </div>
      
      {DAYS.map((day) => (
        <div key={day} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg">
          <div className="flex items-center min-w-[120px]">
            <input
              type="checkbox"
              id={`day-${day}`}
              checked={hours[day].open}
              onChange={() => handleDayToggle(day)}
              className="h-4 w-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
            />
            <label htmlFor={`day-${day}`} className="ml-2 text-sm font-medium text-gray-700">
              {DAY_LABELS[day]}
            </label>
          </div>
          
          {hours[day].open && (
            <div className="flex items-center gap-2 flex-1">
              <input
                type="time"
                value={hours[day].from}
                onChange={(e) => handleTimeChange(day, 'from', e.target.value)}
                className="px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 outline-none text-sm"
              />
              <span className="text-gray-500">{t('timeTo', 'to')}</span>
              <input
                type="time"
                value={hours[day].to}
                onChange={(e) => handleTimeChange(day, 'to', e.target.value)}
                className="px-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 outline-none text-sm"
              />
            </div>
          )}
          
          {!hours[day].open && (
            <span className="text-sm text-gray-400">{t('closed', 'Closed')}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default OpeningHoursInput;
